import { FC } from 'react';
import AddProductProvider from '../memory/memr';
import InitMiddlewareAddBrand from '../middlewares/InitMiddleware';

const AddAdminInstance: FC<{}> = () => {
  return (
    <AddProductProvider>
      <InitMiddlewareAddBrand />
    </AddProductProvider>
  );
};

export default AddAdminInstance;
